import React from "react";
import PropTypes from 'prop-types';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    DataTable,
    Fa,
    Input,
    FormInline,
    Modal,
    ModalBody,
    Spinner,
    Timeline,
    TimelineStep
} from "mdbreact";
import OrderService from '../Security/OrderService/orderService';
import {Redirect} from "react-router-dom";

export default class patientList extends React.Component {
    constructor(props){
        super(props);

        const data = {
            columns: [
                {
                    label: "ID",
                    field: "id",
                    sort: "asc",
                    width: 150
                },
                {
                    label: "Patient Name",
                    field: "name",
                    sort: "asc",
                    width: 200
                },
                {
                    label: "Date of Birth",
                    field: "dateOfBirth",
                    sort: "asc",
                    width: 270
                },
                {
                    label: "Phone Number",
                    field: "phone",
                    sort: "asc",
                    width: 150
                },
                {
                    label: "Order Type",
                    field: "orderType",
                    sort: "asc",
                    width: 270
                },
                {
                    label: "Status",
                    field: "status",
                    sort: "asc",
                    width: 200
                },
                {
                    label: "Setup Date",
                    field: "setupDate",
                    sort: "asc",
                    width: 200
                },
                {
                    label:"Timeline",
                    field:"Timeline",
                    sort:"asc",
                    width:100
                }
            ],
            rows: [
            ]
        };

        this.state={
            data: data,
            isLoaded: false,
            hasSearched: false,
            timelineModalOpen: false,
            timelineModalOrder:{},
            timelineModalEntries:[],
            dateOfBirth:"",
            patientName: '',
            userContextLoaded: props.userContextLoaded,
        };
    }

    static contextTypes = {
        currentAccount: PropTypes.object,
        currentUser: PropTypes.object,
        statusReasons: PropTypes.any
    };

    componentDidMount() {
        this.retrieveOrders();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.userContextLoaded !== this.state.userContextLoaded){
            this.setState({userContextLoaded: nextProps.userContextLoaded});
        }
    }

    formatDate(date) {
        return (new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric'
        }).format(date))
    }

    formatDateSmall(date){
        if(date){
            return new Date(date).toLocaleDateString();
        }
        return "No Date On File"
    }

    formatStatus(order){
        if(order.status === 'Ready to Deliver'){
            return 'Waiting for Delivery'
        }
        else if(order.status === 'Inprocess'){
            if(order.description && order.description === 'Verification'){
                return 'Intake / Insurance Verification';
            }
            else{
                return 'Insurance Review';
            }
        }
        else if(order.status === 'New'){
            return 'Medical Documents';
        }
        else{
            return order.status;
        }
    }

    formatTimelineStatus(timelineEntry){
        const {statusReasons} = this.context;

        if(timelineEntry.reason){
            return statusReasons.get(timelineEntry.reason);
        }
        return null;
    }

    retrieveOrders(){
        if(this.state.searching)
        return OrderService.getOrdersHLAll().then(res => {
            this.sortRecords(res);
        }).catch(err =>{

        })
    }

    searchAccountOrders(name, date){
        //const {currentAccount} = this.context;

        this.setState({isLoaded: false});
        this.setState({hasSearched: true});
        return OrderService.getOrdersHLByName(name).then(res => {
            this.sortRecords(res);
        }).catch(err =>{
        })
    }

    sortRecords(records){
        let ary = [],
            dt = this.state.data;

        if(records == null){
            this.setState({
                data: dt,
                isLoaded: true
            });
            return;
        }

        try {


            records.forEach((order) => {
                ary.push({
                    id: order.id,
                    name: order.patientName,
                    dateOfBirth: order.dateOfBirth,
                    phone: order.phone,
                    orderType: order.orderType,
                    status: this.formatStatus(order),
                    setupDate: this.formatDateSmall(order.setupDate),
                    Timeline: this.renderTimelineButton(order)
                });
            });

        }
        catch (e) {
            console.log(e);
        }

        dt.rows = ary;

        this.setState({
            data: dt,
            isLoaded: true
        });
    }

    toggleTimelineModalPopup(currentOrder) {
        let newState = !this.state.timelineModalOpen;


        //We don't want to call the endpoint if the modal is being closed...BC
        if(newState === false){
            this.setState({
                timelineModalOpen: newState
            });
        }
        else{
            OrderService.getOrderTimeline(currentOrder).then(records => {
                if(records){
                    records = records.sort((a,b) => {
                        return a > b ? 1 : -1;
                    })
                }

                this.setState({
                    timelineModalOpen: newState,
                    timelineModalOrder: currentOrder,
                    timelineModalEntries: records
                });
            });
        }
    }

    generateTimelineEntry() {
        if(this.state.timelineModalEntries == null){
            return;
        }

        let small = [];

        this.state.timelineModalEntries.forEach(entry => {
            let stat = this.formatTimelineStatus(entry);

            if(stat !== null){
                entry.status = stat;
                small.push(entry);
            }
        });

        return (
            small.map((att, idx) => {
                let v = true;

                if (idx === 0 || (idx % 2 === 0)) {
                    v = false;
                }

                return (
                    <TimelineStep color="red darken-4" href='#void' inverted={v} key={idx} icon="calendar-check-o">
                        <h4>{att.status}</h4>
                        <hr/>
                        <h6>{this.formatDate(att.updatedOn)}</h6>
                    </TimelineStep>
                )
            })
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();
        console.log('Event: Form Submit');
    };
    renderSearchSection(){
        return(
            <div>
                <FormInline onSubmit={this.handleSubmit}>
                    <Col md={'4'}>
                        <h3 style={{color: 'white', textAlign: 'center'}}>
                        Patient Archive
                    </h3>
                    </Col>
                    <Col md={'4'}>
                        <div className={'patientListName'}>
                            <Input label={'Patient Name'}

                                   style={{width: '100%'}}
                                   value={this.state.patientName}
                                   onChange={(e) =>  this.setState({patientName: e.target.value})}

                                   onKeyPress={event => {
                                       if (event.key === 'Enter') {
                                           this.searchAccountOrders(this.state.patientName)
                                       }
                                   }}
                            />
                        </div>
                    </Col>

                    <Col md={'4'}>
                        <Button  className={'searchBoxPt'}
                            onClick={()=> this.searchAccountOrders(this.state.patientName)}
                            size={'md'}>
                            Search
                        </Button>
                        <Button  className={'searchBoxPt'}
                                 onClick={()=>{
                                     this.setState({
                                         patientName: "",
                                     })
                                     this.searchAccountOrders("")}}
                                 size={'md'}>
                            Clear
                        </Button>
                    </Col>

                </FormInline>
            </div>
        )
    }

    renderTimelineButton(order){
        return(
            <Fa icon={'clock-o'} size={"lg"} onClick={() => this.toggleTimelineModalPopup(order)}> </Fa>
        )
    }

    renderTable(){
        return(
                <DataTable
                    searching={false}
                    entriesOptions={[25,50]}
                    info={false}
                    striped
                    small
                    data={this.state.data}> </DataTable>
            )
    }

    renderLoadingSpinnerOrTable(){
        if(this.state.hasSearched === false){
            return
        }
        if(this.state.isLoaded === false || this.state.userContextLoaded === false) {
            return (
                <Container className="mt-5">
                    <div style={{textAlign: 'center', verticalAlign: 'center'}}>
                        <Spinner multicolor/>
                    </div>
                </Container>
            )
        }
        return(this.renderTable())
    }

    renderTimelineModal(theme) {
        let order = this.state.timelineModalOrder;
        return (
            <div>
                <Modal
                    isOpen={this.state.timelineModalOpen}
                    toggle={() => this.toggleTimelineModalPopup(order)}
                >
                    <CardHeader  style={{backgroundColor: '#2C4163', color: 'white'}}>
                        <h4>
                            {this.formatStatus(order)}
                        </h4>
                        <br/>
                        Updated: {this.formatDate(order.lastUpdatedOn || new Date())}
                    </CardHeader>
                    <ModalBody style={{backgroundColor: 'transparent'}}>
                        {this.renderOrderTimeline(order,theme)}
                    </ModalBody>
                </Modal>
            </div>

        )
    }

    renderOrderTimeline(order,theme) {
        return (
            <Timeline>
                {this.generateTimelineEntry(order,theme)}
            </Timeline>)
    }


    render(){
        const {currentUser} = this.context;

        if(!currentUser.id){
            return (<Redirect to='/login' />);
        }

        return(
            <Container className="mt-5">
                {this.renderTimelineModal()}

                <Card style={{backgroundColor: '#2C4163'}}>
                {this.renderSearchSection()}
                </Card>
                <Card>
                    <CardBody>
                        {this.renderLoadingSpinnerOrTable()}
                    </CardBody>
                </Card>
            </Container>
        )
    }
}